import type { BoxProps } from '@mui/material/Box';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';

// ----------------------------------------------------------------------

export function SignUpTerms({ sx, ...other }: BoxProps) {
  return (
    <Box
      component="span"
      sx={{
        mt: 3,
        display: 'block',
        textAlign: 'center',
        typography: 'caption',
        color: 'text.secondary',
        ...sx,
      }}
      {...other}
    >
      {'By signing up, I agree to '}
      <Link
        href="https://hokela.co.ke/terms-conditions"
        target="_blank"
        rel="noopener noreferrer"
        underline="always"
        color="text.primary"
      >
        Terms of service
      </Link>
      {' and '}
      <Link
        href="https://hokela.co.ke/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        underline="always"
        color="text.primary"
      >
        Privacy policy
      </Link>
      .
    </Box>
  );
}
